import React from "react";
import { Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { useAppLibs } from "../../ContextProvider/AppLib_Provider";

// Register chart components
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

// Criteria mapping

const RadarChart = ({ assessment, labels }) => {
  const { Students } = useAppLibs();
  const criteriaMap = Students.STUDENT_CRITERIA;
  // Extract labels and values from assessment
  labels = labels
    ? labels
    : Object.keys(assessment).map((key) => criteriaMap[key]);
  const values = Object.values(assessment).map((val) => val * 10);

  // Radar chart data
  const data = {
    labels,
    datasets: [
      {
        label: "Student Progress",
        data: values,
        backgroundColor: "rgba(54, 162, 235, 0.2)",
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 2,
      },
    ],
  };

  // Chart options
  const options = {
    scales: {
      r: {
        min: 0,
        max: 100,
        ticks: { stepSize: 10 },
        grid: {
          color: "rgb(100, 181, 246)",
        },
      },
    },
  };

  return <Radar data={data} options={options} />;
};

export default RadarChart;
